import { tv } from 'tailwind-variants'

export const stageRealmVariants = tv({
  slots: {
    container: 'flex flex-col ml-60 space-y-5',
    realmSelection: 'text-h1 font-bold mb-mili',
    choseRealmToAccessApp: 'text-base text-medium',
    iconHint: 'flex flex-row gap-1 mt-mili text-deca items-center',
    containerButton: 'flex flex-row space-x-deca my-kilo'
  }
})
